<template>
  <layout-checkout>
    <template slot="body" v-if="!transaction">
      <a href="#" @click="backToCart($event)">
        <icon-base width="1em" height="1em">
          <icon-angle-left />
        </icon-base> Back to cart
      </a>
      <h3>Checkout</h3>

      <form class="PaB-checkout-form" ref="checkoutForm" @submit="placeOrder($event)">
        <select-field v-if="!!show_order_choice" label="Select Order Type *" :has-error="'order_type' in errors"
          :has-value="order_type ? true : false" :error-msg="errors.order_type">
          <select v-model="order_type">
            <option value='pickup'>Pick Up</option>
            <option value='delivery'>Delivery</option>
          </select>
        </select-field>

        <input-field label="First Name *" :has-error="'first_name' in errors" :has-value="first_name ? true : false"
          :error-msg="errors.first_name">
          <input v-on:keyup.enter="placeOrder" ref="firstFocus" :autocomplete="`${isKiosk() ? 'off' : 'given-name'}`" type="text"
            v-model="first_name">
        </input-field>

        <input-field :label="isKiosk() ? 'Last Name' : 'Last Name *'" :has-error="'last_name' in errors" :has-value="last_name ? true : false"
          :error-msg="errors.last_name">
          <input v-on:keyup.enter="placeOrder" :autocomplete="`${isKiosk() ? 'off' : 'family-name'}`" type="text"
            v-model="last_name">
        </input-field>

        <input-field  v-if="!isKiosk()" label="Email *" :has-error="'email' in errors" :has-value="email ? true : false"
          :error-msg="errors.email">
          <input v-on:keyup.enter="placeOrder" :autocomplete="`${isKiosk() ? 'off' : 'email'}`" type="email" v-model="email">
        </input-field>

        <input-field :label="isKiosk() ? 'Phone Number' : 'Phone Number *'" :hasError="'telephone' in errors"
          :hasValue="telephone ? true : false" :errorMsg="errors.telephone">
          <input :autocomplete="`${isKiosk() ? 'off' : 'tel'}`" type="tel" v-model="telephone" maxlength="14"
            @input="acceptNumber" @change="acceptNumber">
        </input-field>

        <input-field v-if="order_type=='delivery'" label="Street Address *" :hasError="'address' in errors"
          :hasValue="address ? true : false" :errorMsg="errors.address">
          <input v-on:keyup.enter="placeOrder" autocomplete="street-address" type="text" v-model="address">
        </input-field>

        <input-field v-if="order_type=='delivery'" label="City *" :hasError="'city' in errors"
          :hasValue="city ? true : false" :errorMsg="errors.city">
          <input v-on:keyup.enter="placeOrder" autocomplete="locality" type="text" v-model="city">
        </input-field>

        <input-field v-if="order_type=='delivery'" label="State *" :hasError="'state_abbrev' in errors"
          :hasValue="state_abbrev ? true : false" :errorMsg="errors.state_abbrev">
          <input v-on:keyup.enter="placeOrder" autocomplete="region" type="text" v-model="state_abbrev">
        </input-field>

        <input-field v-if="order_type=='delivery'" label="Postal/Zip code *" :hasError="'zipcode' in errors"
          :hasValue="zipcode ? true : false" :errorMsg="errors.zipcode">
          <input v-on:keyup.enter="placeOrder" autocomplete="postal-code" type="text" v-model="zipcode">
        </input-field>

        <div v-if="isPickup() && !isKiosk()" class="PaB-form-input-check" :class="{'has-error': 'agreement' in errors}">
          <p class="PaB-error" v-if="'agreement' in errors">{{ errors.agreement }}</p>
          <checkbox v-model="agreement">I’m aware that I will be picking up my order in store at {{venueInfo.name}}.
          </checkbox>
        </div>

        <div v-if="order_type=='delivery'" class="PaB-form-input-check" :class="{'has-error': 'agreement' in errors}">
          <p class="PaB-error" v-if="'agreement' in errors">{{ errors.agreement }}</p>
          <checkbox v-model="agreement">I understand this order is for delivery and I understand {{venueInfo.name}}'s
            delivery hours.
          </checkbox>
        </div>
      </form>
      <app-button v-if="this.mock_button" type="primary" :block="true" label="Mock Scan" @click.native="mockFill"></app-button>
    </template>

    <template slot="actions" v-if="!transaction">
      <order-summary @onTotalChange="updatedTotal" :items="cart.order_items_attributes"></order-summary>
      <p>
        <icon-base width="1em" height="1em">
          <icon-exclamation-circle />
        </icon-base> Legal limitations for maximum amount of product(s) apply.
      </p>
      <p>
        <icon-base width="1em" height="1em">
          <icon-exclamation-circle />
        </icon-base> Member discounts will be applied <span v-if="isKiosk()">at counter</span><span
          v-else>in-store</span>!
      </p>
      <p v-if="order_type=='pickup' && !isKiosk()">
        <icon-base width="1em" height="1em">
          <icon-exclamation-circle />
        </icon-base> Your order will be ready for pick up in store at {{venueInfo.name}}.
      </p>
      <p v-if="order_type=='delivery'">
        <icon-base width="1em" height="1em">
          <icon-exclamation-circle />
        </icon-base> Your order will be delivered to the provided address during delivery hours.
      </p>
      <div class="PaB-button-group">
        <app-button v-if="isPaymentKiosk()" type="primary" :block="true" label="Pay now" @click.native="setPayment"></app-button>

        <app-button v-else type="primary" :block="true" label="Continue" @click.native="placeOrder"
          :disabled="!isValidCheckout"></app-button>
      </div>
    </template>

  </layout-checkout>
</template>

<style lang="scss">
.PaB-checkout-process__actions {
  align-self: flex-end;
}
</style>

<style lang="scss" scoped>
.posabit-widget h3 {
  margin-top: 1em;
}

.PaB-form-input-check {
  position: relative;

  .PaB-error {
    margin-left: 20px;
    position: absolute;
    bottom: auto;
    top: -1em;
  }
}

.PaB-order-type {
  margin-right: 12px;
  flex: 1 1 200px;
  position: relative;
  select {
    background-image: none;
    display: block;
    width: 100%;
    appearance: none;
    min-height: 44px;
    height: 100%;
    border-radius: 0;
    line-height: 1;
    padding: 10px;
    margin: 0;
    background-color: #fff;
    font-size: inherit;
  }
  svg {
    position: absolute;
    top: 10px;
    right: 10px;
    pointer-events: none;
  }
}

.PaB-error {
  color: #d21313;
  position: absolute;
  bottom: 12px;
  font-size: 12px;
  margin: 0;
}
</style>

<script>
import LayoutCheckout from '@/components/LayoutCheckout'
import OrderSummary from '@/components/OrderSummary'
import AppButton from '@/components/AppButton'
import Checkbox from '@/components/Checkbox'
import InputField from '@/components/InputField'
import SelectField from '@/components/SelectField'
import IconBase from '@/components/IconBase'
import IconExclamationCircle from '@/components/icons/IconExclamationCircle'
import IconAngleLeft from '@/components/icons/IconAngleLeft'
import Cookies from 'js-cookie'

export default {
  components: {
    LayoutCheckout,
    OrderSummary,
    AppButton,
    Checkbox,
    InputField,
    SelectField,
    IconBase,
    IconExclamationCircle,
    IconAngleLeft
  },
  data () {
    var orderType
    if (this.isKiosk()) {
      orderType = 'pickup'
    } else if (this.widgetOptions.config.allow_delivery && this.widgetOptions.config.allow_pickup) {
      orderType = ''
    } else {
      orderType = (this.widgetOptions.config.allow_delivery) ? 'delivery' : 'pickup'
    }

    return {
      order_type: orderType,
      show_order_choice: (orderType === ''),
      first_name: '',
      last_name: '',
      email: '',
      telephone: '',
      address: '',
      city: '',
      state_abbrev: '',
      zipcode: '',
      reference_no: 0,
      agreement: this.isKiosk() ? this.isKiosk() : false,
      errors: {},
      checkoutTotal: 0,
      payment_source: '',
      payment_reference_id: 0,
      payment_amount: 0,
      payment_prepaid: false,
      mock_button: this.displayMockButton()
    }
  },
  computed: {
    cart () {
      return this.$store.state.cart
    },
    isValidCheckout () {
      if (this.widgetOptions.config.kiosk_mode) {
        return this.first_name
      }
      if (
        !this.first_name ||
        !this.telephone ||
        !this.validTelephone(this.telephone) ||
        !this.agreement ||
        !this.order_type
      ) {
        return false
      }
      if (
        !this.isKiosk() &&
        (!this.email ||
        !this.validEmail(this.email) ||
        !this.last_name)
      ) {
        return false
      }
      // Check delivery requirements
      if (this.order_type === 'delivery') {
        if (
          !this.address ||
          !this.city ||
          !this.state_abbrev ||
          !this.zipcode
        ) {
          return false
        }
      }

      return true
    },
    venueInfo () {
      return this.$store.state.venue.info
    },
    transaction () {
      if (window.transaction) {
        this.finishOrder()
        return true
      } else {
        return false
      }
    }
  },
  created () {
    // Back to cart if no items
    if (this.cart.order_items_attributes.length === 0) {
      this.backToCart()
    }
    const trackProducts = this.cart.order_items_attributes.map(product => {
      const parentProduct = this.$store.getters['products/findProduct'](product.product_parent_id)
      return {
        'id': product.product_id,
        'name': product.product_name,
        'brand': product.product_brand,
        'category': parentProduct.category,
        'price': product.price,
        'quantity': product.quantity
      }
    })
    this.eventTracking.checkout(trackProducts)
    this.eventTracking.sendPageview(this.$router.currentRoute.fullPath)
  },
  mounted () {
    this.$refs.firstFocus.focus()
  },
  methods: {
    validateCheckout () {
      this.errors = {}

      if (!this.first_name) {
        this.errors['first_name'] = 'First name is required'
      }

      if (!this.last_name && !this.isKiosk()) {
        this.errors['last_name'] = 'Last name is required'
      }

      if (this.widgetOptions.config.kiosk_mode) return

      if (!this.telephone) {
        this.errors['telephone'] = 'Telephone is required'
      } else if (!this.validTelephone(this.telephone)) {
        this.errors['telephone'] = 'A valid telephone is required'
      }

      if (!this.email) {
        this.errors['email'] = 'Email is required'
      } else if (!this.validEmail(this.email)) {
        this.errors['email'] = 'A valid email is required'
      }

      if (!this.agreement) {
        this.errors['agreement'] = "You must agree that you're aware of the pickup location"
      }

      if (!this.order_type) {
        this.errors['order_type'] = 'You must choose an order type.'
      }

      if (this.order_type === 'delivery') {
        if (!this.address) {
          this.errors['address'] = 'Address Line 1 is required'
        }
        if (!this.city) {
          this.errors['city'] = 'City is required'
        }
        if (!this.state_abbrev) {
          this.errors['state_abbrev'] = 'State is required'
        }
        if (!this.address) {
          this.errors['zipcode'] = 'Zipcode is required'
        }
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validTelephone: function (telephone) {
      // var re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
      // Simplified phone number regex and accept a preceding country code.
      var re = /^(\+[1-9])?[0-9]{10,15}$/
      return re.test(telephone.replace(/[-. ()]/g, ''))
    },
    acceptNumber () {
      var x = this.telephone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.telephone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
    },
    isPickup () {
      return this.order_type === 'pickup' && !this.isKiosk()
    },
    isKiosk () {
      return !!this.widgetOptions.config.kiosk_mode
    },
    displayMockButton () {
      return !!this.widgetOptions.config.mock_button
    },
    isPaymentKiosk () {
      if (typeof Android !== 'undefined') {
        // eslint-disable-next-line
        return Android.isPaymentKiosk() && this.isKiosk()
      } else {
        return false
      }
    },
    placeOrder (e) {
      if (e) { e.preventDefault() }
      this.validateCheckout()
      if (Object.keys(this.errors).length === 0) {
        this.$store.dispatch('cart/setFirstName', this.first_name)
        this.$store.dispatch('cart/setLastName', this.last_name)
        this.$store.dispatch('cart/setEmail', this.email)
        this.$store.dispatch('cart/setTelephone', this.telephone)
        this.$store.dispatch('cart/setOrderType', this.isKiosk() ? 'kiosk' : this.order_type)
        this.$store.dispatch('cart/setaddress', this.address)
        this.$store.dispatch('cart/setCity', this.city)
        this.$store.dispatch('cart/setStateAbbrev', this.state_abbrev)
        this.$store.dispatch('cart/setZipcode', this.zipcode)
        this.$store.dispatch('cart/setSource', this.isKiosk() ? 'online_kiosk' : 'online_store')

        this.$store.dispatch('cart/setPaymentSource', this.payment_source)
        this.$store.dispatch('cart/setPaymentReferenceId', this.payment_reference_id)
        this.$store.dispatch('cart/setPaymentAmount', this.payment_amount)
        this.$store.dispatch('cart/setPaymentPrepaid', this.payment_prepaid)

        const currentRoute = this.$router.currentRoute.fullPath
        const routeParts = currentRoute.split('/checkout')
        const routePath = routeParts[0].replace(/\/$/, '')

        var lastPhone = Cookies.get('phone')
        if (lastPhone && lastPhone !== this.telephone) {
          Cookies.remove('pa')
        }

        if (!this.widgetOptions.config.kiosk_mode && this.$store.getters['venue/getACH'] && !this.isPaymentKiosk()) {
          this.$router.push(`${routePath}/payment`)
        } else {
          this.$store.dispatch('cart/placeOrder')
          this.$router.push(`${routePath}/order`)
        }
      } else {
        this.$refs.checkoutForm.scrollIntoView()
      }
    },
    backToCart (e) {
      if (e) {
        e.preventDefault()
      }
      const currentRoute = this.$router.currentRoute.fullPath
      const routeParts = currentRoute.split('/checkout')
      if (!routeParts[0]) {
        this.$router.push('/')
      } else {
        this.$router.push(`${routeParts[0]}`)
      }
    },
    finishOrder () {
      this.payment_source = 'posabit dtp'
      this.payment_amount = this.checkoutTotal
      this.payment_prepaid = true
      window.transaction = false
      this.placeOrder()
    },
    setPayment () {
      this.reference_no = Math.floor(Math.random() * 1000) + 1
      this.$store.dispatch('cart/setReferenceNo', this.reference_no)
      // eslint-disable-next-line
      Android.chargeOrderId(this.reference_no, (this.checkoutTotal/100.0))
    },
    updatedTotal (value) {
      this.checkoutTotal = value
    },
    mockFill () {
      const loyaltyArray = [
        { 'fname': 'Jon', 'lname': 'Baugher', 'phone_number': '425-941-0771' },
        { 'fname': 'BRIAN', 'lname': 'GILL', 'phone_number': '556-865-5668' },
        { 'fname': 'WILLIAM', 'lname': 'GREENBURG', 'phone_number': '206-333-3333' },
        { 'fname': 'RYAN', 'lname': 'RICHARD HAMLIN', 'phone_number': '425-503-9121' },
        { 'fname': 'BRADEN', 'lname': 'HAMLIN', 'phone_number': '425-999-0424' },
        { 'fname': 'NATHANIEL', 'lname': 'CASSANO', 'phone_number': '210-452-9511' },
        { 'fname': 'Keane', 'lname': 'Faulkner', 'phone_number': '333-444-5555' },
        { 'fname': 'Randall', 'lname': 'Mansell', 'phone_number': '556-677-8888' },
        { 'fname': 'Abdallah', 'lname': 'Everett', 'phone_number': '667-778-8899' },
        { 'fname': 'Arvin', 'lname': 'Mcdermott', 'phone_number': '556-778-9089' }
      ]
      const randomNumber = Math.ceil(Math.random() * 10)

      this.first_name = loyaltyArray[randomNumber].fname
      this.last_name = loyaltyArray[randomNumber].lname
      this.telephone = loyaltyArray[randomNumber].phone_number
    }
  }
}
</script>
